import React, { FC } from 'react';
import FormikInput from '@minecraft.formik-input';
import { FilterData } from '../../../shared/types';
import { Label } from '../../../shared/styles';

type Props = FilterData;

const PiercingsNote: FC<Props> = ({ name, label }) => {
  return (
    <>
      <Label>{label}</Label>
      <FormikInput name={name} size="small" />
    </>
  );
};

export default PiercingsNote;
